import { Container, Carousel, Row, Col, Image } from 'react-bootstrap';


const Apartments = () => {
  return (
    <Container className='w-100 bg-light pt-3 pb-3' fluid>
      <h3 className='sectionalText'>Apartments</h3>
      <Container className='carouselContainers' fluid>
        <Row className='d-flex align-items-center m-0 w-100'>
          <Col md ={12} lg={8} className='h-100'>
            <Carousel className='h-100'>
            <Carousel.Item>
                <Image src='./images/apartmentImages/img1.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img2.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img3.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img4.jpg' alt='' className="d-block w-100 apartmentsImg"  />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img5.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img6.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img7.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img8.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img9.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img10.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img11.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
              <Carousel.Item>
                <Image src='./images/apartmentImages/img12.jpg' alt='' className="d-block w-100 apartmentsImg" />
              </Carousel.Item>
            </Carousel>
          </Col>
          <Col md ={12} lg={4} className='h-100'>
            <Row className='d-flex justify-content-center align-items-center p-1'> 
              <Col  lg= {12} className='bg-light p-2 shadow-lg'>
                <p className='apartmentsTitle'>Two bedroom, One Bathroom - $2,200</p>
              </Col>
              <Col lg= {12} className='bg-light p-2 mt-2 shadow-lg'>
                <p className='apartmentsHeader'>Features</p>
                <p className='apartmentsDescription'>
                  - Stainless Steel Appliances 
                  - Open-floor Concept
                  - Storage 
                  - Vinyl flooring 
                  - Shared laundry 
                  - Microwave 
                  - Dishwasher 
                  - Refrigerator 
                  - Elevator 
                  - Central Air 
                  - Parking              
               </p>
              </Col>
              <Col lg= {12} className='bg-light p-2 mt-2 shadow-lg'>
                <p className='apartmentsHeader'>Description</p>
                <p className='apartmentsDescription'>
                  Welcome to your brand-new two bedroom apartment, thoughtfully designed with modern living in mind. Located in a vibrant mixed-use community, this home offers convenience and comfort. Featuring open-concept layout, equipped with stainless steel appliances, and ample storage space. Step outside and explore the lively neighborhood featuring charming cafes, restaurant variety, and more just steps away!  
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Apartments;
